import { Component, OnInit } from '@angular/core';
import { IAssessment } from '../interfaces/iassessment';
import { Observable, Subject } from 'rxjs';
import { HistoryService } from '../services/history.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-assessment-history',
  templateUrl: './assessment-history.component.html',
  styleUrls: ['./assessment-history.component.scss']
})
export class AssessmentHistoryComponent implements OnInit {
  public tpno : number;
  public assessments : Array<IAssessment>;
  public assessmentHistory$: Observable<boolean>;
  public selectedCriteria:number=0;
  public searchValue: any = '';
  dtOptions: DataTables.Settings = {};
  // We use this trigger because fetching the list of purpose can be quite long,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject();
  

  searchCriteria = [
    {value: "0", desc: "SELECT SEARCH CRITERIA"},
    {value: "1", desc: "ASSESSMENT NO."},
    {value: "2", desc: "TAX PAYER NO."},
    {value: "3", desc: "TAX TYPE NO."},
    {value: "4", desc: "TAX PERIOD"},
    {value: "5", desc: "REASSESSMENT NO."},
    {value: "6", desc: "TAX ACCOUNT NO."}
  ];


  constructor(private history : HistoryService) { }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true,
      paging:   true,
      ordering: true,
      info:     true
    };
    this.tpno = parseInt(localStorage.getItem("tpn"));
    this.assessmentHistory$ = this.history.getAssessmentHistorys(this.tpno).pipe(tap(r => {
      this.assessments = this.history.assessmentHistory;
    }))
  }

  filterAssessmentHistory(criteria:number, searchvalue:any){
    let originalPaymentData = this.assessments;
    this.selectedCriteria= criteria;
    this.searchValue = searchvalue;
    if(this.selectedCriteria==1 && this.searchValue != ""){
      this.assessments = this.assessments.filter(element=>element.ASSESS_NO==this.searchValue);
    }
    else if(this.selectedCriteria==2 && this.searchValue != ""){
      this.assessments = this.assessments.filter(e=>e.TAX_PAYER_NO==this.searchValue)
    }
    else if(this.selectedCriteria==3 && this.searchValue != ""){
      this.assessments=this.assessments.filter(e=>e.TAX_TYPE_NO==this.searchValue)
    }
    else if(this.selectedCriteria==4 && this.searchValue != ""){
      this.assessments=this.assessments.filter(e=>e.TAX_PERIOD==this.searchValue)
    }
    else if(this.selectedCriteria==5 && this.searchValue != ""){
      this.assessments= this.assessments.filter(e=>e.REASSESSMENT_NO==this.searchValue);
    }
    else if(this.selectedCriteria==6 && this.searchValue != ""){
      this.assessments= this.assessments.filter(e=>e.TAX_ACCOUNT_NO==this.searchValue);
    }
    else{
      this.assessments = originalPaymentData;
    }
   
  }


}
